import { createDefaultFormatters, createStandardConfig } from './utils'

/**
 * Ireland Address Configuration
 */
export const IE_CONFIG = createStandardConfig({
  countryCode: 'IE',
  countryName: 'Ireland',
  requiresStreetNumber: false,
  formatters: createDefaultFormatters(),
  fieldOverrides: {
    address1: {
      googleTypes: ['street_number', 'route', 'street_address'],
      preferLongName: true,
      labelKey: 'address-config.street-address-or-area',
      errorKey: 'address-config.street-address-or-area-required'
    },
    address2: {
      googleTypes: ['subpremise', 'premise'],
      labelKey: 'address-config.apt-unit'
    },
    city: {
      googleTypes: [
        'locality',
        'postal_town',
        'sublocality_level_1',
        'administrative_area_level_2'
      ],
      labelKey: 'address-config.city-town',
      errorKey: 'address-config.city-town-required'
    },
    stateOrProvince: {
      required: false,
      preferLongName: true,
      labelKey: 'address-config.county'
    },
    postalCode: {
      labelKey: 'address-config.eircode',
      errorKey: 'address-config.eircode-required'
    }
  },
  addressPrecision: 'postalCode'
})
